import { Commit as CommitIcon } from "components/icons/generated";
import { Commit, VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";
import { getRepoRevisionUrl } from "utils/spaceliftRepo";
import { providerHasVcsHost } from "utils/vcs";

import MetaInfoListItem from "./Item";

type MetaInfoCommitProps = {
  commit: Commit;
  provider: VcsProvider;
  vcsIntegrationId?: string;
  fullWidth?: boolean;
};

const MetaInfoCommit = ({
  commit,
  provider,
  vcsIntegrationId,
  fullWidth,
}: MetaInfoCommitProps) => {
  const commitLabel = getCommitLabel(provider, commit.hash);

  // Blob Storage has no VCS host, so the commit points nowhere: render the hash as
  // plain text rather than a dead link.
  if (!providerHasVcsHost(provider)) {
    return (
      <MetaInfoListItem
        icon={CommitIcon}
        tooltip={`Commit set by ${commit.authorName}`}
        type="commit"
        fullWidth={fullWidth}
      >
        {commitLabel}
      </MetaInfoListItem>
    );
  }

  // Spacelift Repos has no external VCS host either, but unlike Blob it does have an
  // internal commit page to link to.
  const isSpacelift = provider === VcsProvider.Spacelift;
  const commitUrl =
    isSpacelift && vcsIntegrationId
      ? getRepoRevisionUrl(vcsIntegrationId, commit.hash)
      : commit.url;

  return (
    <MetaInfoListItem
      href={commitUrl}
      linkText={commitLabel}
      icon={CommitIcon}
      tooltip={`Commit set by ${commit.authorName}`}
      target="_blank"
      type="commit"
      fullWidth={fullWidth}
    />
  );
};

export default MetaInfoCommit;
